module.exports = "/assets/dist/images/menu_personal_shopper.png?e9822775f0fd999b05acefc1cc99bf79";